import { useEffect, useRef } from 'react';

export default function Home({ onNavigate }) {
  const titleRef = useRef(null);

  useEffect(() => {
    const el = titleRef.current;
    if (!el) return;
    const onMove = (e) => {
      const rect = el.getBoundingClientRect();
      const x = ((e.clientX - rect.left) / rect.width) * 100;
      const y = ((e.clientY - rect.top) / rect.height) * 100;
      el.style.setProperty('--mx', `${x}%`);
      el.style.setProperty('--my', `${y}%`);
    };
    el.addEventListener('mousemove', onMove);
    return () => el.removeEventListener('mousemove', onMove);
  }, []);

  return (
    <main className="page home">
      <nav className="nav">
        <div className="nav-left">
          <div className="logo-mark" aria-hidden="true">
            <span className="logo-dot" />
          </div>
          <span className="logo-word mono">APPSHELL</span>
        </div>
        <a className="nav-contact" href="mailto:hello@appshell.co">
          hello@appshell.co
        </a>
      </nav>

      <section className="hero">
        <button className="about-pill" onClick={() => onNavigate('about')}>
          <span className="pill-dot" />
          <span>About Us</span>
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none" aria-hidden="true">
            <path d="M1 6h10M7 2l4 4-4 4" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </button>
        <h1 className="hero-title" ref={titleRef} data-text="APPSHELL">
          APPSHELL
        </h1>
        <p className="hero-sub">Crafting premium software experiences.</p>
        <div className="hero-orbit" aria-hidden="true">
          <span className="orbit-line" />
          <span className="orbit-dot" />
        </div>
      </section>

      <footer className="footer">
        <span className="footer-brand">© 2026 APPSHELL LLC</span>
        <div className="footer-links">
          <button className="footer-link" onClick={() => onNavigate('privacy')}>
            Privacy Policy
          </button>
          <span className="footer-dot">·</span>
          <button className="footer-link" onClick={() => onNavigate('terms')}>
            Terms of Use
          </button>
          <span className="footer-dot">·</span>
          <button className="footer-link" onClick={() => onNavigate('content')}>
            Content Policy
          </button>
        </div>
      </footer>
    </main>
  );
}
